import { makeAuthenticatedRequest, parseErrorResponse } from '../../../core/api/client';

export const notificationsApi = {
  getUnread: async () => {
    const response = await makeAuthenticatedRequest('/api/v1/notifications/');
    if (!response.ok) {
      const errorMessage = await parseErrorResponse(response);
      throw new Error(errorMessage);
    }
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  },
  getUnreadCount: async () => {
    const response = await makeAuthenticatedRequest('/api/v1/notifications/count');
    if (!response.ok) {
      const errorMessage = await parseErrorResponse(response);
      throw new Error(errorMessage);
    }
    return await response.json();
  },
  markRead: async (id) => {
    const response = await makeAuthenticatedRequest(`/api/v1/notifications/${id}/read`, {
      method: 'PATCH',
    });
    if (!response.ok) {
      const errorMessage = await parseErrorResponse(response);
      throw new Error(errorMessage);
    }
    return await response.json();
  },
};
